import { ADMIN_ROLES } from "@/lib/auth-constants";
import type { Role } from "@/lib/auth-types";
import { useAuthContext } from "./auth-provider";

export function useAuth() {
	const auth = useAuthContext();

	const hasRole = (role: Role): boolean => {
		return auth.user?.roles.includes(role) ?? false;
	};

	const hasAnyRole = (roles: Role[]): boolean => {
		return roles.some((role) => hasRole(role));
	};

	const isAdmin = (): boolean => {
		return hasAnyRole(ADMIN_ROLES);
	};

	return {
		...auth,
		hasRole,
		hasAnyRole,
		isAdmin,
	};
}
